import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-background-100 px-4 py-20 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-compass-3-line text-3xl" aria-hidden="true" />
      </span>
      <p className="mt-6 font-display text-5xl text-primary-500">404</p>
      <h1 className="mt-3 font-display text-2xl text-foreground-950">这个页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址可能已经被移动或删除。不如回首页看看最新爆料，或者直接去广场翻一翻。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line mr-1.5" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/feed"
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          去爆料广场
        </Link>
      </div>
    </div>
  );
}